import React, { useEffect, useState } from 'react'
import './plan.scss';
import PageContent from '../../components/PageContent/PageContent';
import CustomTitle from '../../components/UI/title/CustomTitle';
import Tariffs from './components/Tariffs/Tariffs';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { setButtonClick, setIconButton, setIsShowButton, setTextButton } from '../../store/buttonSlice';
import { setIsShowButtonNot } from '../../store/buttonNotSlice';
import useMixpanel from '../../hooks/useMixpanel';

export default function PlanNew() {

    const dispatch = useDispatch();
    const history = useHistory();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const buttonClicked = useSelector((state) => state.button.buttonClicked);
    const nextPage = useSelector((state) => state.appRoute.nextPage);
    useEffect(() => {
        dispatch(setIsShowButton(true));
        dispatch(setTextButton('Get my plan'));
        dispatch(setIconButton(''));
        dispatch(setIsShowButtonNot(false));
    }, []);

    const { trackP1Event } = useMixpanel();

    useEffect(() => {
        if (buttonClicked) {
            dispatch(setButtonClick(false));
            // trackP1Event(eventName, {})
            queryParams.set('planId', planId);
            trackP1Event('onboarding_plan', {})
            history.push({
                pathname: nextPage,
                search: `?${queryParams.toString()}`
            });
        }
    }, [buttonClicked, dispatch]);

    const [activePlan, setActivePlan] = useState('1');
    const [planId, setPlanId] = useState(1);
    return (
        <div className="page">
            <PageContent>
                <div className="page-content">
                    <CustomTitle
                        style={{ marginBottom: '24rem' }}
                        title={'Choose your plan with<br>up to 70% discount'}
                    />
                    <Tariffs setActivePlan={setActivePlan} activePlan={activePlan} setPlanId={setPlanId} planId={planId} />
                </div>
            </PageContent>
        </div>
    )
}
